document.addEventListener("DOMContentLoaded", function() {

	var $ = jQuery.noConflict();

	// Keep native anchor links below the fixed header, with 300px of breathing room.
	var header = document.querySelector('header.site-header');
	var adminBar = document.getElementById('wpadminbar');
	function updateAnchorOffset() {
		var headerBottom = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
		var adminBarBottom = adminBar ? Math.max(0, adminBar.getBoundingClientRect().bottom) : 0;
		document.documentElement.style.scrollPaddingTop = Math.ceil(Math.max(headerBottom, adminBarBottom) + 300) + 'px';
	}
	updateAnchorOffset();
	window.addEventListener('resize', updateAnchorOffset);
	if (header && window.ResizeObserver) {
		new ResizeObserver(updateAnchorOffset).observe(header);
	}

	// Reposition direct hash links once images and fonts have finished loading.
	function alignHashTarget() {
		updateAnchorOffset();
		if (!window.location.hash) return;
		var target;
		try {
			target = document.getElementById(decodeURIComponent(window.location.hash.slice(1)));
		} catch (error) {
			return;
		}
		if (target) target.scrollIntoView({ block: 'start', behavior: 'instant' });
	}
	function alignLoadedHashTarget() {
		function alignAfterLayout() {
			requestAnimationFrame(function() {
				requestAnimationFrame(alignHashTarget);
			});
		}
		alignAfterLayout();
		if (document.fonts) document.fonts.ready.then(alignAfterLayout);
	}
	if (document.readyState === 'complete') {
		alignLoadedHashTarget();
	} else {
		window.addEventListener('load', alignLoadedHashTarget);
	}

	var lastScrollTop = 0;
	
	$(window).scroll(function(e) {    
		var scroll = $(window).scrollTop();
		var HeroHeader = $('.sticky-header');
		var st = $(this).scrollTop();

		if (scroll >= 0) {
			$(HeroHeader).addClass("onScroll");
		} else {
			$(HeroHeader).removeClass("onScroll");
		}

		if (st > lastScrollTop) {
			$(HeroHeader).removeClass("onScrollUp");
		} else {
			$(HeroHeader).addClass("onScrollUp");
		}

		lastScrollTop = st;

		if (scroll >= 94) {
			$('.scroll-up').removeClass('hidden');
			$('.site-header').addClass('static');
			$('.list-menu').addClass('sticky');
		} else {
			$('.scroll-up').addClass('hidden');
			$('.site-header').removeClass('static');
			$('.list-menu').removeClass('sticky');
		}
	});

	setTimeout(function() {
		$('.acf-form-sent').text('');
		if ( $('.acf-form-sent').hasClass('acf-form-sent') ) {
			history.replaceState(null, null, ' ');
		}
	}, 2000);

	// Scroll Up button
	$('.scroll-up').click(function(e) {
		page.animate({
			scrollTop : 0,
		}, 100);
		e.preventDefault();
	});

	// Scroll Down button
	$('.scroll-down').click(function(e) {
		var SlideHeight = $('.hero-home').height();
		// /console.log(SlideHeight);
		page.animate({
			scrollTop : page.scrollTop() + SlideHeight,
		}, 100);
		e.preventDefault();
	});
});
